import { cx } from "@emotion/css";
import { PropTypes } from "prop-types";

const EstimationRowLayout = ({ titleClassName, titleSection, contentSection, detailsSection, ...restProps }) => (
  <>
    <div className={cx("col-5 mb-3 pl-0", titleClassName)}>{titleSection}</div>
    <div className="d-flex col-5 mb-3 px-0 gap-2" {...restProps}>
      <span className="text-fw-bold">{contentSection}</span>

      {detailsSection && <span>{detailsSection}</span>}
    </div>
  </>
);

EstimationRowLayout.defaultProps = {
  titleClassName: null,
  detailsSection: null,
};

EstimationRowLayout.propTypes = {
  titleClassName: PropTypes.string,
  titleSection: PropTypes.node.isRequired,
  contentSection: PropTypes.node.isRequired,
  detailsSection: PropTypes.node,
};

export default EstimationRowLayout;
